import {
  IconBuildingBridge,
  IconDropletHalf2,
  IconHexagons,
  IconKeyframes,
  IconMapPin,
  IconTarget,
  IconWash,
} from '@tabler/icons-react';

export const SudsIcons = {
  'Attenuation storage': <IconWash size={16} />,
  Bioretention: <IconHexagons size={16} />,
  'Detention basin': <IconWash size={16} />,
  'Downpipe disconnection': <IconWash size={16} />,
  'Filter drains': <IconHexagons size={16} style={{ transform: 'rotate(90deg)' }} />,
  'Filter strips': <IconHexagons size={16} />,
  'Green Roof': <IconTarget size={16} />,
  Infiltration: <IconKeyframes size={16} style={{ transform: 'rotate(90deg)' }} />,
  'Ponds wetlands': <IconDropletHalf2 size={16} />,
  'Proprietary treatment': <IconBuildingBridge size={16} />,
  Swales: <IconBuildingBridge size={16} />,
  Trees: <IconTarget size={16} />,
  default: <IconMapPin size={16} />,
};
